import {useState} from 'react';

import {useTranslation} from 'react-i18next';

import {Grid, IconButton, SxProps, Typography} from '@mui/material';

import {DreamEmployerModal} from '../DreamEmployerModal';

import {GradientIcon, InfoIcon, RibbonTrophyIcon} from '../../../../../../../assets/employee_satisfaction_bar';
import EmpionDialog from '../../../../../../../components/EmpionDialog/EmpionDialog';
import {greenColors, orangeColors} from '../../../../../../../layouts/theme/designSystem';
import {DreamEmployerLegacyClass} from '../../../types/DreamEmployerTypes';

interface Props {
  dreamEmployerData: DreamEmployerLegacyClass;
  isClickable?: boolean;
  backgroundColor?: string;
  fillColorGradientIcon?: string;
  fillColorRibbonIcon?: string;
  typographyStyles?: SxProps;
  iconSize?: {height: string; width: string};
}

export const DreamEmployerBarLegacy = ({
  dreamEmployerData,
  isClickable,
  backgroundColor,
  fillColorGradientIcon,
  fillColorRibbonIcon,
  typographyStyles,
  iconSize,
}: Props) => {
  const {t} = useTranslation();

  const [open, setOpen] = useState<boolean>(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <Grid container mt={8} position={'relative'}>
      <Grid item bgcolor={'white'} width={'100%'} height={'76px'} borderRadius={'16px'}>
        <Grid
          item
          bgcolor={backgroundColor || (orangeColors[4])}
          width={'70%'}
          height={'76px'}
          borderRadius={'16px 0px 0px 16px'}
          display={'flex'}
          justifyContent={'flex-end'}
          position={'relative'}
        >
          <GradientIcon
            fill={fillColorGradientIcon || (orangeColors[4])}
            height={'76px'}
            width={'134px'}
            style={{position: 'absolute', right: '-115px'}}
          />
        </Grid>
      </Grid>

      <Grid
        item
        container
        height={'76px'}
        position={'absolute'}
        padding={'16px'}
        justifyContent={'space-between'}
        alignItems={'center'}
        flexDirection={'row'}
        wrap={'nowrap'}
      >
        <Grid item display={'flex'} alignItems={'center'}>
          <RibbonTrophyIcon
            fill={fillColorRibbonIcon || greenColors[700]}
            height={iconSize?.height || '16px'}
            width={iconSize?.width || '16px'}
          />
          <Typography
            variant='body1'
            sx={{
              color: greenColors[700],
              marginLeft: '8px',
              ...typographyStyles,
            }}
          >
            {t('companyCultureDashboard.employeeSatisfaction.dreamEmployer', {
              percent: dreamEmployerData.totalScore,
            })}
          </Typography>
        </Grid>
        {isClickable && (
          <Grid item>
            <IconButton onClick={handleOpen}>
              <InfoIcon fill={greenColors[700]} height={24} width={24} />
            </IconButton>
            <EmpionDialog open={open} onClose={handleClose} maxWidth={'sm'}>
              <Typography variant='h2' mb={2}>
                <DreamEmployerModal dreamEmployerData={dreamEmployerData} handleClose={handleClose} />
              </Typography>
            </EmpionDialog>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};
